import {
    BorderWidth,
    Colors,
    Spacing,
} from 'app/koddi-components/src/_ChakraComponents/ChakraTheme';
import { CText } from 'app/koddi-components/src/_ChakraComponents/Typography';
import { useMemo } from 'react';
import { MultiValueProps } from 'react-select';
import { OptionType } from '../../../Types';
import { TooltipWrapper } from './TooltipWrapper.component';

export const SimpleMultiValue = ({
    getValue,
    ...props
}: MultiValueProps<OptionType> & { hideCount?: boolean }): JSX.Element => {
    const values = getValue();
    const tooltipList = useMemo(() => {
        if (!Array.isArray(values)) return [];
        const first20 = values.slice(0, 19);
        const totalLeftOver = values.length - 20;
        const leftOverString =
            totalLeftOver > 0
                ? `${totalLeftOver.toLocaleString()} more selected`
                : '';
        return [...first20.map(({ label }) => label), leftOverString].filter(
            Boolean
        );
    }, [values]);

    if (
        // @ts-ignore
        props?.index > 0 ||
        !Array.isArray(values) ||
        props?.selectProps?.hideCount
    )
        return <></>;

    const count = values.length.toLocaleString();

    return (
        <TooltipWrapper
            label={tooltipList.map((value) => (
                <div key={value}>{value}</div>
            ))}
            isDisabled={!tooltipList.length}
            hasArrow
            portalProps={{ appendToParentPortal: true }}
        >
            <CText
                text={count}
                noWrap
                isTruncated
                borderRight={`${BorderWidth.Thinnest} solid`}
                borderRightColor={Colors.gray}
                pr={Spacing.XS}
                mr={Spacing.XS}
            />
        </TooltipWrapper>
    );
};
